import React from 'react';

const ITServicesServices = () => {
  return (
    <main style={{ padding: 40, minHeight: '60vh' }}>
      <h1>AILYT IT Services — Services</h1>
      <p>Detailed breakdown of services: Web Development, Mobile Apps, MVP, Reltio/MDM, Data Analytics, Automation & Integrations.</p>
    </main>
  );
};

export default ITServicesServices;
